import Model from "flarum/common/Model";
export default class VerificationRequest extends Model {
  status() {
    return Model.attribute("status").call(this);
  }
  documentType() {
    return Model.attribute("documentType").call(this);
  }
  documentPath() {
    return Model.attribute("documentPath").call(this);
  }
  reason() {
    return Model.attribute("reason").call(this);
  }
  adminNote() {
    return Model.attribute("adminNote").call(this);
  }
  createdAt() {
    return Model.attribute("createdAt", Model.transformDate).call(this);
  }
  updatedAt() {
    return Model.attribute("updatedAt", Model.transformDate).call(this);
  }
  handledAt() {
    return Model.attribute("handledAt", Model.transformDate).call(this);
  }
  user() {
    return Model.hasOne("user").call(this);
  }
  handler() {
    return Model.hasOne("handler").call(this);
  }
  apiEndpoint() {
    return "/verification-requests" + ("id" in this.data ? "/" + this.data.id : "");
  }
  isPending() {
    return this.status() === "pending";
  }
  isApproved() {
    return this.status() === "approved";
  }
  isRejected() {
    return this.status() === "rejected";
  }
}
flarum.reg.add('ziiven-verified', 'common/models/VerificationRequest', VerificationRequest);